/**
 * Web / default: no-op. LiveKit on web uses `livekit-client` against the
 * browser's native WebRTC, so there are no globals to register. Metro picks
 * `registerLiveKit.native.ts` on iOS/Android where the shim IS required.
 */
export function registerLiveKit(): void {
  /* no-op on web */
}
